// extracted by mini-css-extract-plugin
export default {"mainContainer":"EmailValidated_mainContainer__msUiz","pageSection":"EmailValidated_pageSection__2wvkh","title":"EmailValidated_title__wXFVF"};